import { render, staticRenderFns } from "./otchetOrders.vue?vue&type=template&id=7f59ad47"
import script from "./otchetOrders.vue?vue&type=script&lang=js"
export * from "./otchetOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports